import { irm_actionNotAllowedOnThisItem } from 'owa-locstrings/lib/strings/irm_actionnotallowedonthisitem.locstring.json';
import { WaitForActionDialogText } from './showActionBlockedDialog.locstring.json';
import loc, { format } from 'owa-localize';
import { confirm } from 'owa-confirm-dialog';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Should dialog box when S/MIME response is either disabled or blocked
 */
const showActionBlockedDialog = itemActionString => {
    const messageString = format(
        isFeatureEnabled('cmp-smime') && isFeatureEnabled('rp-smime')
            ? loc(WaitForActionDialogText)
            : loc(irm_actionNotAllowedOnThisItem),
        itemActionString
    );
    confirm(null /* title */, messageString, false /* resolveImmediately */, {
        hideCancelButton: true,
    });
};

export default showActionBlockedDialog;
